import { render, staticRenderFns } from "./CreditBillingSingle.vue?vue&type=template&id=bd632d9c&scoped=true&"
import script from "./CreditBillingSingle.vue?vue&type=script&lang=js&"
export * from "./CreditBillingSingle.vue?vue&type=script&lang=js&"
import style0 from "./CreditBillingSingle.vue?vue&type=style&index=0&id=bd632d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd632d9c",
  null
  
)

export default component.exports